
import { mixins, Options } from 'vue-class-component';
import { BaseWidgets, DataWidgetName, isRecognisedWidgetName } from '@/exported';
import { MCheckoutWidgetPropProvider } from './MCheckoutWidgetProps';
import MCheckout from './widget/MCheckout.vue';
import MTokenCart from './widget/MTokenCart.vue';
import MTokenCartItemDelete from './widget/MTokenCartItemDelete.vue';

@Options({
  components: {
    // Note: Adding all other widgets that use the CheckoutWidgetMixin here
    MCheckout,
    MTokenCart,
    MTokenCartItemDelete
  }
})
export default class MCheckoutWrapper extends mixins(MCheckoutWidgetPropProvider) {
  parentDataWidgetName: DataWidgetName | null = null;
  mounted(): void {
    const widgetName = this.$el?.parentElement?.getAttribute('data-widget') || '';
    if (!widgetName || !isRecognisedWidgetName(widgetName)) {
      this.parentDataWidgetName = null;
    }
    this.parentDataWidgetName = widgetName;
  }

  get dynamicComponent() {
    if (!this.parentDataWidgetName || !BaseWidgets[this.parentDataWidgetName]) {
      return null;
    }
    return BaseWidgets[this.parentDataWidgetName].component;
  }
}
